import SelectableCardGroup from "ui/common/components/surface/SelectableCardGroup/SelectableCardGroup";
import { GiftCardsFiltersProps } from "./GiftCardsFilters.types";
import { BottomElement, GIFTCARDS_FILTERS, GiftcardsFilter } from "./GiftCardsFiltersOptions";
import { Col, Typography } from "@commonlibs";
import { useState, useEffect } from "react";
import { LocaleTranslationResource, useTranslate } from "ui/locale";
import { CategorizedGiftCards } from "ui/giftcards/types/giftcard.types";

export default function GiftCardsFilters({ giftCards, onFilterGiftCards, onFilterCategories }: GiftCardsFiltersProps) {
    const translate = useTranslate();
    const [bottomElement, setBottomElement] = useState<BottomElement | undefined>(GIFTCARDS_FILTERS[0].bottomElement);
    const [selectedValue, setSelectedValue] = useState<string>(GIFTCARDS_FILTERS[0].selectableCard.value);

    const selectableCards = GIFTCARDS_FILTERS.map((item) => ({
        ...item.selectableCard,
        label: translate(item.selectableCard.label as LocaleTranslationResource),
    }));

    useEffect(() => {
        const selectedOption = findFilter(selectedValue);
        if (!selectedOption) return;
        const filteredGiftCards = filterGiftCards(selectedOption);
        filterCategories(filteredGiftCards);
    }, [giftCards]);

    const onFilterChange = (value: string) => {
        setSelectedValue(value);
        const selectedOption = findFilter(value);
        setBottomElement(selectedOption?.bottomElement);

        const filteredGiftCards = filterGiftCards(selectedOption!);
        filterCategories(filteredGiftCards!);
    };

    const filterGiftCards = (selectedOption: GiftcardsFilter) => {
        const filteredGiftCards = selectedOption?.filter(giftCards) ?? {};
        const cleanedGiftCards = Object.fromEntries(Object.entries(filteredGiftCards).filter(([_, value]) => value.length > 0));
        onFilterGiftCards(cleanedGiftCards);
        return cleanedGiftCards;
    };

    const filterCategories = (giftCards: CategorizedGiftCards) => {
        const filteredCategories = Object.keys(giftCards).filter((key) => giftCards[key].length > 0);
        onFilterCategories(filteredCategories);
        return filteredCategories;
    };

    const findFilter = (selectedFilter: string) => {
        const filter = GIFTCARDS_FILTERS.find((item) => item.selectableCard.value === selectedFilter);
        return filter;
    };

    return (
        <Col style={{ marginBottom: "-10px" }}>
            <SelectableCardGroup
                onCardChange={onFilterChange}
                defaultValue={GIFTCARDS_FILTERS[0].selectableCard.value}
                items={selectableCards}
            />
            {bottomElement && (
                <Col style={{ marginTop: "10px" }}>
                    <Typography variant="body3Strong" style={{ fontSize: "14px" }}>
                        {translate(bottomElement.title)}
                    </Typography>
                    <Typography variant="body4Regular" style={{ fontSize: "11px" }}>
                        {translate(bottomElement.text)}
                    </Typography>
                </Col>
            )}
        </Col>
    );
}
